import { useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";

interface RenderContentDateRangeProps {
    startDate: any,
    endDate: any,
    setDateRangeSearch: (val: any) => void;
}

export const RenderContentDateRange = ({
    startDate,
    endDate,
    setDateRangeSearch,
}: RenderContentDateRangeProps) => {
    const { t, i18n } = useTranslation();
    const optionToLabelMapping: any = {
        last_1_hour: t("Last 1 hour"),
        last_3_hour: t("Last 3 hours"),
        last_24_hour: t("Last 24 hours"),
    };
    const LABEL_OPTIONS = ["last_1_hour", "last_3_hour", "last_24_hour"]?.map(
        (item: string) => optionToLabelMapping[item]
    );

    const LAST_HOUR = [
        {
            label: optionToLabelMapping?.last_1_hour,
            value: 1,
        },
        {
            label: optionToLabelMapping?.last_3_hour,
            value: 3,
        },
        {
            label: optionToLabelMapping?.last_24_hour,
            value: 24,
        },
    ];
    const allPresets = [LAST_HOUR].flat();
    const presets = allPresets?.filter((preset: any) =>
        LABEL_OPTIONS?.includes(preset?.label)
    );
    const handlePresetClick = (preset: any, isEnd = false) => {
        let newStart = new Date();
        let newEnd = new Date();
        switch (preset?.value) {
            case 1:
                newStart = new Date(new Date().setHours(new Date().getHours() - 1));
                newEnd = new Date();
                break;
            case 3:
                newStart = new Date(new Date().setHours(new Date().getHours() - 3));
                newEnd = new Date();
                break;
            case 24:
                newStart = new Date(new Date().setHours(new Date().getHours() - 24));
                newEnd = new Date();
                break;
            default:
                break;
        }

        setDateRangeSearch([newStart, newEnd]);
    };
    const checkActive = (
        starD: any,
        endD: any,
        presetValue: any,
        presetLabel: any
    ) => {
        const timeStampStart = new Date(starD)?.getTime();
        const timeStampEnd = new Date(endD)?.getTime();
        const diff = (timeStampEnd - timeStampStart) / 3600000;
        return diff === presetValue;
    };
    // render 2 input to enter start date and end date and left sidebar have 2 option today and yesterday
    return (
        <div className="d-flex date-picker-wrapper-custom  gap-2 ">
            <DatePicker
                locale={i18n?.language === "ko" ? "ko" : "en"}
                className="form-control search "
                popperClassName="form-control-popper-date-picker-range"
                useShortMonthInDropdown={true}
                dateFormat="yyyy-MM-dd HH:mm"
                showTimeSelect
                selected={startDate}
                onChange={(date) => setDateRangeSearch([date, endDate])}
                maxDate={endDate}
                timeCaption={t("Time")}
            >
                <div className="picker-presets">
                    <ul className="color-scrollbar-os">
                        {presets.map((preset) => (
                            <li
                                key={preset.label}
                                onClick={() => handlePresetClick(preset, true)}
                                className={
                                    startDate &&
                                        endDate &&
                                        checkActive(startDate, endDate, preset.value, preset.label)
                                        ? "preset-active"
                                        : ""
                                }
                                ref={(el: any) => {
                                    if (
                                        startDate &&
                                        endDate &&
                                        checkActive(
                                            startDate,
                                            endDate,
                                            preset.value,
                                            preset.label
                                        )
                                    ) {
                                        el?.scrollIntoView({
                                            behavior: "smooth",
                                            block: "nearest",
                                            inline: "start",
                                        });
                                    }
                                }}
                            >
                                {preset.label}
                            </li>
                        ))}
                    </ul>
                </div>
            </DatePicker>
            <p className="py-2">→</p>
            <DatePicker
                locale={i18n?.language === "ko" ? "ko" : "en"}
                className="form-control search "
                popperClassName="form-control-popper-date-picker-range"
                useShortMonthInDropdown={true}
                dateFormat="yyyy-MM-dd HH:mm"
                showTimeSelect
                selected={endDate}
                onChange={(date) => setDateRangeSearch([startDate, date])}
                minDate={startDate}
                maxDate={new Date()}
                timeCaption={t("Time")}
            >
                <div className="picker-presets">
                    <ul className="color-scrollbar-os">
                        {presets.map((preset) => (
                            <li
                                key={preset.label}
                                onClick={() => handlePresetClick(preset, false)}
                                className={
                                    startDate &&
                                        endDate &&
                                        checkActive(startDate, endDate, preset.value, preset.label)
                                        ? "preset-active"
                                        : ""
                                }
                                ref={(el: any) => {
                                    if (
                                        startDate &&
                                        endDate &&
                                        checkActive(
                                            startDate,
                                            endDate,
                                            preset.value,
                                            preset.label
                                        )
                                    ) {
                                        el?.scrollIntoView({
                                            behavior: "smooth",
                                            block: "nearest",
                                            inline: "start",
                                        });
                                    }
                                }}
                            >
                                {preset.label}
                            </li>
                        ))}
                    </ul>
                </div>
            </DatePicker>
        </div>
    );
};
